<div class="mat-list-wrapper" *ngIf="partHealthLogItems|async as items; else loading">
  <mat-list role="list" *ngIf="items.length; else noItems" fusePerfectScrollbar>
    <ng-container *ngFor="let item of items">
      <mat-list-item role="listitem" class="list-item" (click)="navigateToPartHealth(item.partNumber)">
        <h3 matLine>{{item.partNumber}}</h3>
        <p matLine class="part-number-type">{{getPartNumberType(item.type)}}</p>
        <p matLine class="date">{{item.date | date}}</p>
      </mat-list-item>
      <mat-divider class="separator"></mat-divider>
    </ng-container>
  </mat-list>
  <ng-template #noItems>
    <div class="no-items">
      <h3>No items</h3>
    </div>
  </ng-template>
</div>
<ng-template #loading>
  <div class="spinner-wrapper">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
</ng-template>
